/**
 * Copyright (C) 2026 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

const HEX_RADIX = 16;
const PAD_LENGTH = 2;

const toHex = (bytes: Uint8Array): string =>
  Array.from(bytes)
    .map(byte => byte.toString(HEX_RADIX).padStart(PAD_LENGTH, '0'))
    .join('');

export const hashEmailSha256 = async (email: string): Promise<string> => {
  if (!window.crypto || !window.crypto.subtle) {
    throw new Error('Web Crypto API is unavailable.');
  }

  const emailBytes = new TextEncoder().encode(email);
  const digest = await window.crypto.subtle.digest('SHA-256', emailBytes);
  return toHex(new Uint8Array(digest));
};
